import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import 'flag-icons/css/flag-icons.min.css';

import { retrieveDetailledIpAddressInformationsByIp } from '../../../../store/networkManagment/actions';

interface CreationIpProps {
  ipAddress? : string | null ;
}

// « IP de création : 1.2.3.4 (🇫🇷 Ville) ». Sans IP (créations antérieures au suivi)
// rien n'est rendu ; sans géolocalisation on n'affiche que l'IP.
const CreationIp: React.FC<CreationIpProps> = ({ ipAddress }) => {
  const [ place , setPlace ] = useState<{ city: string, countryCode: string } | null>(null);

  useEffect(() => {
    setPlace(null);
    if (!ipAddress) return;
    let cancelled = false;
    retrieveDetailledIpAddressInformationsByIp(ipAddress)
      .then(details => {
        if (cancelled || !details) return;
        setPlace({ city: details.ipApiCom_city, countryCode: (details.ipApiCom_countryCode || '').toLowerCase() });
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [ipAddress]);

  if (!ipAddress) return null;

  return (
    <span>
      {`IP de création : ${ipAddress}`}
      {place && (place.city || place.countryCode) && (
        <>
          {' ('}
          {place.countryCode && <span className={classNames('fi', `fi-${place.countryCode}`)} />}
          {place.city && ` ${place.city}`}
          {')'}
        </>
      )}
    </span>
  );
};

export default CreationIp;
